<template>
    <div id="currencies-switcher" class="px-3">
        <span class="nav-link px-2 header-btn text-white" @click.prevent="isOpen = !isOpen">
            {{ $t('currencies.' + currency.label) }}
        </span>
        <div class="currencies-switcher_items" v-if="isOpen" v-on-click-outside="closeWidget">
            <div class="currencies-switcher_item py-1 px-2"
                v-for="currencyItem in currencies"
                v-show="currencyItem.value !== currency.value"
                :key="currencyItem.value"
                @click.prevent="selectCurrency(currencyItem)"
            >
                {{ $t('currencies.' + currencyItem.label) }} 
            </div>
        </div>
    </div>
</template>

<script>
import { vOnClickOutside } from '@vueuse/components'
import apiService from '@/services/api.service'
import { mapState } from 'vuex'

export default {
    name: 'AppCurrenciesSwitcher',
    data() {
        return {
            isOpen: false,
            currencies: [{
                label: 'all',
                value: null
            }],
            currency: {
                label: 'all',
                value: null
            }
        }
    },
    directives: {
        onClickOutside: vOnClickOutside
    },
    mounted() {
        const cookieCurrency = this.$root.$cookies.get("site_currency");
        if(cookieCurrency){
            this.currency = this.$root.$cookies.get("site_currency");
            this.$store.commit('setCurrency', this.currency.value);
        }
        this.loadCurrencies();
    },
    computed: {
        ...mapState({
            locale: state => state.locale,
        })
    },
    methods: {
        closeWidget(){
            this.isOpen = false
        },
        selectCurrency(currency){
            this.currency = currency;
            this.isOpen = !this.isOpen;
            this.$root.$cookies.set('site_currency', this.currency, "10y");
            localStorage.setItem('site_currency', this.currency);
            this.$store.commit('setCurrency', this.currency.value);
        },
        loadCurrencies(){
            apiService.getFrApi({
                url: 'prices/getCurrencyList',
                method: 'get',
                locale: this.locale
            }).then(response => {
                const currencies = response.data.data;
                currencies.unshift({
                    label: 'all',
                    value: null
                });
                this.currencies = currencies;
            }).catch(() => {
            })
        }
    }
}
</script>

<style scoped>
#currencies-switcher {
    position: relative;
}
#currencies-switcher span.title{
    position: relative;
    cursor: pointer;
}
#currencies-switcher span.title{
    position: relative;
    display: block;
    overflow: hidden;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0,0,0,.2);
}
#currencies-switcher span.title img{
    position: absolute;
    top: -5px;
    width: 30px;
    right: -5px;
}
#currencies-switcher .currencies-switcher_items{
    background: #fff;
    position: absolute;
    right: calc(50% - 200px);
    width: 200px;
    margin-top: 6px;
    transform: translateX(-50%);
    box-shadow: 0 2px 4px rgba(0, 0, 0, .2);
    border-radius: 6px;
    z-index: 10;
}
#currencies-switcher .currencies-switcher_item:hover{
    cursor: pointer;
    background-color: hsla(0, .001%, 80%, .333);
}

.currencies-switcher_item-image{
    width: 20px;
}
#currencies-switcher .currencies-switcher_items::after {
    content: '';
    position: absolute;
    top: -4px;
    left: 50%;
    width: 10px;
    height: 10px;
    background-color: #fff;
    transform: translateX(-50%) rotate(45deg);
}
</style>